import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { LENDING_PRODUCT_URL, LOAN_UPDATE_EXPENSE_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class UpdateLendingProductRequest extends BaseApiRequest {
  method = METHOD.HTTP.PUT;

  body = [];

  url = LENDING_PRODUCT_URL;

  constructor(applicationId, doximProductId, payLoad) {
    super();
    this.body = payLoad;
    const paramList = [applicationId, doximProductId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
